import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

import { PaginationHelper } from '@helper/pagination.helper';
import { QueryHelper } from '@helper/query.helper';
import { Emergency, EmergencyFilters, EmergencyFiltersParams } from '@type/emergency.type';
import { Page } from '@type/page.type';

@Injectable({
  providedIn: 'root',
})
export class EmergencyService {
  private readonly http = inject(HttpClient);

  private readonly _refresh$ = new Subject<void>();
  readonly refresh$ = this._refresh$.asObservable();

  triggerRefresh(): void {
    this._refresh$.next();
  }

  getEmergency(options?: {
    page?: number;
    pageSize?: number
  }, filters?: EmergencyFilters): Observable<Page<Emergency>> {
    const pageParams = PaginationHelper.getPageQueryParams(options?.page, options?.pageSize);
    const filterParams = new HttpParams({ fromObject: filters as EmergencyFiltersParams });

    const queryParams = QueryHelper.mergeQueryParams([pageParams,
      filterParams]);

    return this.http.get<Page<Emergency>>(`emergency?${queryParams.toString()}`);
  }

  getEmergencyById(emergencyId: number): Observable<Emergency> {
    return this.http.get<Emergency>(`emergency/${emergencyId}`);
  }

  setEmergencyAcknowledged(emergencyId: number): Observable<Emergency> {
    return this.http.post<Emergency>(`emergency/${emergencyId}/acknowledge`, {});
  }
}
